import * as Headless from '@headlessui/react';
import {
  forwardRef,
  type ComponentPropsWithoutRef,
  type ReactElement,
  type ReactNode,
} from 'react';
import type { OtsComboboxOption } from './OtsCombobox';

type OptionsPanelProps = ComponentPropsWithoutRef<'div'> & {
  staticOptions?: ReactNode;
};
const OptionsPanel = forwardRef<HTMLDivElement, OptionsPanelProps>(
  function OptionsPanel({ staticOptions, children, ...props }, ref) {
    return (
      <div {...props} ref={ref}>
        {staticOptions ?? children}
      </div>
    );
  }
);

export const isOtsComboboxOptionDisabled = (option: OtsComboboxOption) =>
  !!option?.disabled;

/** Keeps Headless UI in virtual mode throughout loading and filtering. Small result sets
 * use ordinary option rows; the virtual renderer only mounts for large catalogs. */
export const OtsComboboxOptions = ({
  options,
  renderOption,
  emptyMessage,
  className,
}: {
  options: OtsComboboxOption[];
  renderOption: (option: OtsComboboxOption) => ReactElement;
  emptyMessage: string;
  className?: string;
}) => (
  <Headless.ComboboxOptions
    as={OptionsPanel}
    className={className}
    staticOptions={
      options.length > 100 ? undefined : options.length ? (
        options.map(renderOption)
      ) : (
        <div className="px-2.5 py-2 text-xs text-[var(--ots-text-muted)]">
          {emptyMessage}
        </div>
      )
    }
  >
    {({ option }) => renderOption(option)}
  </Headless.ComboboxOptions>
);
